import { IConfigBasicData } from '@shared/model/basic-data';
import { createReducer, on } from '@ngrx/store';
import {
  getConfigSuccess,
  getCountriesSuccess,
  getCountryRegionsSuccess,
  getCurrenciesSuccess,
  getIndustriesSuccess,
  getSegmentsSuccess,
} from '../actions';

const initialState: IConfigBasicData = {
  countries: undefined,
  regions: undefined,
  currencies: undefined,
  currency_multiplication: undefined,
  financing_type: undefined,
  industries: undefined,
  segments: undefined,
  time_detalizations: undefined,
};

export const configReducer = createReducer(
  initialState,
  on(getConfigSuccess, (state, { config }) => ({ ...state, ...config })),
  on(getSegmentsSuccess, (state, { segments }) => ({ ...state, segments })),
  on(getIndustriesSuccess, (state, { industries }) => ({ ...state, industries })),
  on(getCurrenciesSuccess, (state, { currencies }) => ({ ...state, currencies })),
  on(getCountriesSuccess, (state, { countries }) => ({ ...state, countries })),
  on(getCountryRegionsSuccess, (state, { regions }) => ({ ...state, regions })),
);
